'use client'

import { useState, useEffect } from 'react'
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/16/solid'
import { CheckIcon } from '@heroicons/react/20/solid'

export default function SelectClientsProjects(props) {
	const clientsProjectsArr = props.array
	const editingEntry = (props.editingEntry) ? props.editingEntry : ''
	//const indexOfEditingEntry = (editingEntry) ? clientsProjectsArr.findIndex(obj => obj.projects.ID === editingEntry.project[0].ID) : 0
  const foundClientProject = (editingEntry) ? clientsProjectsArr.find(client => {return  client.projects.find(p => {return p.ID === editingEntry.project[0].ID})}) : ''
  const foundProject = (editingEntry) ? foundClientProject.projects.find(proj => proj.ID === editingEntry.project[0].ID) : ''
  const initialState = (editingEntry) ? foundProject : ''
	const [selected, setSelected] = useState('')
	const handleChange = (e) => {
		setSelected(e)
		props.handleChangeSelect(e.ID)
	}
   useEffect(() => {
    setSelected(initialState)
 }, [props.filterHasCleared])
    

  return (
    <>
    {clientsProjectsArr.length > 0 && 
      <Listbox value={selected} onChange={(e) => handleChange(e)} >
        <Label className="block sr-only text-sm font-medium text-gray-900">{props.label}</Label>
        <div className="relative w-full">
          <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white px-4 py-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-indigo-600 sm:text-md">
            <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
              <span className="block truncate">{selected ? selected.post_title : props.label}</span>
            </span>
            <ChevronUpDownIcon
              aria-hidden="true"
              className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
            />
          </ListboxButton>

          <ListboxOptions
            transition
            className="absolute z-10 mt-1 max-h-56 w-100 overflow-auto rounded-md bg-white py-1 text-base text-xs shadow-lg outline outline-1 outline-black/5 data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in "
          >
            {clientsProjectsArr.map((clientProject) => (
              <div key={clientProject.ID}>

                {clientProject.projects.map( proj => (
                  <ListboxOption
                    key={proj.ID}
                    value={proj}
                    className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                  >
                    <div className="flex items-center">
                      <span className="ml-3 block truncate font-normal group-data-[selected]:font-semibold">
                        [{clientProject.client_name}] {proj.post_title}

                      </span>
                    </div>

                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[:not([data-selected])]:hidden group-data-[focus]:text-white">
                      <CheckIcon aria-hidden="true" className="size-5" />
                    </span>
                  </ListboxOption>
                ))}
              </div>
            ))}
          </ListboxOptions>
        </div>
      </Listbox>
    }
    </>
  )


}
